// Bootstrap
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

// FontAwesome
import '../node_modules/@fortawesome/fontawesome-pro/css/all.min.css';

// Global UI
import './App.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { unregister } from './registerServiceWorker';

// Set up Redux
import { Provider } from 'react-redux'; // https://github.com/reactjs/react-redux
import { reduxStore } from './services/GeckoStore/redux.js';

import Gecko from './services/gecko/gecko';

ReactDOM.render(<Provider store={reduxStore}><App /></Provider>, document.getElementById('root'));

unregister();

// Set the region if we are on a region url (for GeckoJS)
var regionParse = /^app-([^.]+)/.exec(window.location.host);
if (regionParse && regionParse[1]) {
    Gecko.setRegion(regionParse[1]);
}

// Default to EU region for app.geckoform.com
else if (/^app\.geckoform\.com/.test(window.location.host)) {
    Gecko.setRegion('eu');
}
